import { TuiInput, TuiTextfield } from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { RequestDTO } from '@core/types/Request';
import { RequestService } from '@core/services/request/request.service';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  OwnerLogistFullname = 'ownerLogistFullname',
  OwnerLogistPhone = 'ownerLogistPhone',
  LeasingProduct = 'leasingProduct',
  ExtendedProgram = 'extendedProgram',
}

type FormType = Pick<
  RequestDTO,
  | 'ownerLogistFullname'
  | 'ownerLogistPhone'
  | 'leasingProduct'
  | 'extendedProgram'
>;

@Component({
  selector: 'x-request-form-common-logists',
  imports: [TuiTextfield, ReactiveFormsModule, TuiInput, TranslatePipe],
  templateUrl: './request-form-common-logists.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonLogistsComponent implements OnInit {
  protected readonly permissionService = inject(OutkeepPermissionService);
  protected readonly FormFields = FormFields;
  private readonly formBuilder = inject(FormBuilder);
  private readonly parentForm = inject(FormGroupDirective);
  private readonly requestService = inject(RequestService);
  protected formGroup = this.formBuilder.group<FormType>({
    [FormFields.OwnerLogistFullname]: '',
    [FormFields.OwnerLogistPhone]: '',
    [FormFields.LeasingProduct]: '',
    [FormFields.ExtendedProgram]: '',
  });

  $readOnly = input<boolean>(false, { alias: 'readOnly' });

  constructor() {
    effect(() => {
      if (this.$readOnly()) {
        this.formGroup.disable();
      }
    });
  }

  ngOnInit() {
    this.formGroup.patchValue(this.requestService.$request());
    this.parentForm.form.addControl('logists', this.formGroup);
  }
}
